package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_03_14_Day_5() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("“The Cloud Chaser” docks in Kostigan harbor around midday. The city sits atop a massive cliff. Cranes and elevators transport freight up and down the cliffs, and a long path of switchbacks snakes up the cliff for pedestrians.")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Falorn regrets exposing Captain Leah L’Seth, her crew, and “The Cloud Chaser” to so much danger and insists on paying an extra 150 gold.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Tuesday shrinks Aloysius, the battle cow, so it can more easily exit the lower deck.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Bigglesworth takes 40 pounds of tuna “for the road.”")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The port warden, Master Jameson Thorbury, approaches “The Cloud Chaser” and requests a 15 gold docking fee as well as 2 gold per passenger.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Falorn contacts Elrovir Rodiridan (Lady Aventary’s husband) via Sending.")
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.QUOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" The Friends of the Forest, the heroes of Veldekar, have arrived in Kostigan. Where should we meet?")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Elrovir responds that he is one day away. He’ll meet the heroes at the Stealthy Elf Inn. Falorn asks a guard near the docks for directions. The heroes start to ascend the switchbacks — Caper rides her Battle Cow while the other heroes walk. The residents and travelers of the city appear to be mostly humans, elves, and dwarves — the Friends of the Forest, particularly Bigglesworth, Caper, and Tuesday, will continue to draw attention.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("As the heroes reach the top of the cliff, the city’s stone walls extend an additional 18 feet above the ground. At the gate, a guard asks the heroes to pay 2 gold per person to enter. Tuesday tells the guard that they have already paid at the docks. Tuesday asks the guard about hags and dragons, and the guard says that there was a white dragon to the west centuries ago.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes enter the city and follow the directions the guard down at the docks gave. The buildings are made of stone and wood, the streets are wide, and everything looks well-cared for. They pass “The Port House” Inn.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The Stealthy Elf Inn is covered in vines, and the door is green. Caper walks down an alley to the stables and talks to Jeff, the stable boy. She is satisfied by his dedication to animals and the facilities, and she tips him one gold. The heroes enter the inn and meet the wood elf proprietor, Skel Sunborn. Caper asks for room, food & drink, and stabling. Bigglesworth stores his tuna in cold storage. Skel tells the heroes that there is a wizard tower in the city. The patrons in the tavern appear to be merchants and craftsmen such as stone masons.")
    }
}
